import { SequenceMenu } from '@sequencehq/core-components'
import { FC, ReactElement } from 'react'
import { useNotifications, SimpleModal } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const UnpublishWorkflowModal: FC<{
  trigger: ReactElement
  automationId: string
  versionId: string
  onSuccess?: () => void
}> = ({ trigger, automationId, versionId, onSuccess }) => {
  const { displayNotification } = useNotifications()

  const deactivateVersionMutation = useMutation(
    dashboardv99990101Client.postDeactivateAutomationVersion,
    {
      onSuccess: () => {
        displayNotification('Workflow unpublished', { type: 'success' })
      },
      onError: () => {
        displayNotification('Failed to unpublish workflow', {
          type: 'error'
        })
      }
    }
  )

  return (
    <SimpleModal
      trigger={trigger}
      variant="dialog"
      title="Unpublish workflow"
      submitButtonText="Unpublish"
      submittingButtonText="Unpublishing..."
      isDestructive
      onSubmit={async () => {
        const res = await deactivateVersionMutation.mutateAsync({
          automationId,
          versionId
        })

        if (res && onSuccess) {
          onSuccess()
        }

        return Boolean(res)
      }}
    >
      Are you sure you want to unpublish this workflow?
    </SimpleModal>
  )
}

export const UnpublishWorkflowMenuItem: FC<{
  automationId: string
  versionId: string
  onSuccess?: () => void
}> = ({ automationId, versionId, onSuccess }) => {
  return (
    <UnpublishWorkflowModal
      trigger={
        <SequenceMenu.Item
          key="unpublish-workflow"
          uuid="unpublish-workflow"
          label="Unpublish workflow"
          data-testid="automations.editor.kebabMenu.unpublish"
        />
      }
      automationId={automationId}
      versionId={versionId}
      onSuccess={onSuccess}
    />
  )
}
